module.exports = __webpack_public_path__ + "img/Malleolo_LAT_DX.3d45b84b.png";